// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Q2ZN","content":"RecentSearches_content__flaDm"};